import { Link } from 'react-router-dom'
import {
  Building2, ChevronRight, ClipboardList, FileSignature, MessageCircle, UsersRound,
} from 'lucide-react'

const ITENS = [
  {
    href: '/configuracoes/whatsapp',
    label: 'WhatsApp',
    desc: 'Conexão, webhook, templates e limites de envio.',
    icon: MessageCircle,
  },
  {
    href: '/protocolos',
    label: 'Protocolos',
    desc: 'Preparação de consulta — questionários e checklists versionados.',
    icon: ClipboardList,
  },
  {
    href: '/termos',
    label: 'Termos',
    desc: 'Modelos, versões e solicitações de aceite ou assinatura.',
    icon: FileSignature,
  },
  {
    href: '/equipe',
    label: 'Equipe',
    desc: 'Membros, convites e permissões do workspace.',
    icon: UsersRound,
  },
  {
    href: '/clinicas',
    label: 'Clínicas',
    desc: 'Contextos de origem dos pacientes (consultório, externa, integração).',
    icon: Building2,
  },
]

export default function ConfiguracoesPage() {
  return (
    <div>
      <header style={{ marginBottom: 20 }}>
        <h1 className="page-title">Configurações</h1>
        <p className="page-subtitle" style={{ margin: 0 }}>
          Protocolos, termos, equipe, clínicas e integrações do workspace.
        </p>
      </header>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {ITENS.map(item => {
          const Icon = item.icon
          return (
            <Link
              key={item.href}
              to={item.href}
              className="card"
              style={{
                padding: '16px 18px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
              }}
            >
              <div
                aria-hidden
                style={{
                  width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                  background: 'var(--primary-soft)', color: 'var(--primary-deep)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
              >
                <Icon size={20} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{item.label}</div>
                <div style={{ fontSize: 13.5, color: 'var(--text-secondary)', marginTop: 2 }}>
                  {item.desc}
                </div>
              </div>
              <ChevronRight size={18} aria-hidden style={{ color: 'var(--muted)', flexShrink: 0 }} />
            </Link>
          )
        })}
      </div>
    </div>
  )
}
